/*! License details at fancyapps.com/license */
const t=t=>"string"==typeof t;export{t as isString};
